import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContextHelpButton from '../ContextHelpButton';

// PRODUCT-IA-CLEANUP-001A: extracted from the historical `personas` tab
// inline JSX in ProjectView.js — this is the Personas contextual
// destination inside the DNA workspace. Self-contained (own load of
// `/personas/{project.id}`), reusing the exact same endpoint as before.
export default function PersonasSection({ api, project }) {
  const { t } = useTranslation();
  const [personas, setPersonas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!project?.id) return;
    setLoading(true);
    api.get(`/personas/${project.id}`)
      .then(r => setPersonas(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [api, project?.id]);

  if (loading) {
    return <p className="text-sm text-[var(--text-muted)] py-8">{t('common.loading')}</p>;
  }

  return (
    <div className="pt-2 pb-10">
      <div className="mb-3 flex justify-end"><ContextHelpButton articleId="personas" label="Guida Personas" /></div>
      <div className="personas-grid">
        {personas.map((p, i) => (
          <div key={i} className="card persona-card">
            <h3 className="font-semibold text-base md:text-lg mb-1">{p.name}</h3>
            <p className="text-sm text-[var(--text-secondary)] mb-3">{p.role}</p>
            {p.pain_points && (
              <div className="p-3 rounded-lg text-sm mb-2" style={{ background: 'rgba(236,72,153,0.1)' }}>
                <span className="text-[var(--text-muted)] text-xs font-semibold uppercase">{t('project.personas.painPoints')}</span>
                {(Array.isArray(p.pain_points) ? p.pain_points : [p.pain_points]).map((pp, j) => <p key={j} className="text-sm mt-1">- {pp}</p>)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
